import { Store } from 'typesafe-actions'
import { createStore, applyMiddleware } from 'redux'
import rootReducer from 'REDUCERS'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage/session'
import createSagaMiddleware from 'redux-saga'
import saga from '../sagas'
const sagaMiddleware = createSagaMiddleware()

export const enhancer = applyMiddleware(sagaMiddleware)

const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

let REDUX_STORE: Store

export function getStore() {
  if (!REDUX_STORE) {
    REDUX_STORE = createStore(persistedReducer, enhancer)
    sagaMiddleware.run(saga)
  }
  const persistor = persistStore(REDUX_STORE)

  return { store: REDUX_STORE, persistor }
}
